import { useDispatch } from 'react-redux';
import { useAppSelector } from '@/store/hooks';
import {
  selectChartWidgetIndex,
  selectWidgetTitle,
  selectWidgetView,
  updateWidgetTitle,
} from '@/features/dashboard/dashboardSlice';
import React from 'react';
import { completed } from '@/actions/helpers';
import { WIDGET_CONFIGURATION_UPDATED } from '@/actions/constants';

export const useUpdateChartTitle = () => {
  const dispatch = useDispatch();
  const widgetView = useAppSelector(selectWidgetView);
  const chartWidgetIdx = useAppSelector(selectChartWidgetIndex);
  const customName = useAppSelector(selectWidgetTitle);
  const [name, setName] = React.useState(
    customName ?? widgetView?.name() ?? '',
  );

  React.useEffect(() => {
    if (widgetView && name !== (customName ?? widgetView?.name())) {
      const widgetTitle = name || widgetView.name();
      dispatch(updateWidgetTitle(widgetTitle));
      dispatch(
        completed(WIDGET_CONFIGURATION_UPDATED, {
          widgetIndex: chartWidgetIdx,
          widgetTitle,
        }),
      );
    }
  }, [name, widgetView]);

  const updateName = (event: React.ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);

  return [!!widgetView, name, updateName] as const;
};
